// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tFA53HLM49TojgswKpgw {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    background-color: var(--qa-feedbackPopupBackgroundColor);
    color: var(--qa-feedbackPopupTextColor);
    border-radius: 10px;
    padding: 12.5px;
    border: 1px solid #afafaf;
    width: 350px;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.wuVTcOx9Cyla0bXuLREg {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    margin: 0;
    font-size: 20px;
}

.fRKBqBbl0zAPaYP2jAY0 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    gap: 20px;
}

.fRKBqBbl0zAPaYP2jAY0 h4 {
    margin: 0;
    padding: 0;
}

.u_kMnwAo_LtK74Pw8crQ {
    background-color: transparent;
    color: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-size: 60px;
}

/* .feedbackContent button:hover {
    background-color: #f0f0f0;
} */

.u_kMnwAo_LtK74Pw8crQ:hover {
    transform: scale(1.05);
    transition: transform 0.3s ease-in-out;
}

.u_kMnwAo_LtK74Pw8crQ img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.fp2Vddi8CjvvnhiRxEvS {
    cursor: pointer;
}

.lqJif_9RGRt2DpEY_4Um {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

.EGJ7IWl6dkBMy00XsLiR {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 5px;
  border: 0.5px solid #d7d7d7;
  padding: 5px;
  width:300px;
}

.EGJ7IWl6dkBMy00XsLiR textarea {
  width: 100%;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.2;
  background-color: transparent;
  margin: 0;
  box-sizing: border-box;
}

.EGJ7IWl6dkBMy00XsLiR textarea:focus {
  outline: none;
}

.ZT25zWpgswIDHvBACbN1 {
  background-color: var(--qa-primary);
  color: rgb(105, 105, 105);
  opacity: 0.6;
  padding: 0px 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  align-self: flex-end;
  font-size: 16px;
}

.ZT25zWpgswIDHvBACbN1:hover {
  opacity: 1;
}

.N0MmVqhXhhby2u0KoBV3 {
  font-size: 20px;
}

.SIwfy4sfM2OBjatKyugx {
  font-size: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./app/components/FeedbackPopUp/FeedbackPopUp.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,wDAAwD;IACxD,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".feedbackPopUp {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 10;\n    background-color: var(--qa-feedbackPopupBackgroundColor);\n    color: var(--qa-feedbackPopupTextColor);\n    border-radius: 10px;\n    padding: 12.5px;\n    border: 1px solid #afafaf;\n    width: 350px;\n    min-height: 150px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.feedbackHeader {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    font-size: 20px;\n}\n\n.feedbackContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    gap: 20px;\n}\n\n.feedbackContent h4 {\n    margin: 0;\n    padding: 0;\n}\n\n.ratingButton {\n    background-color: transparent;\n    color: transparent;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    font-size: 60px;\n}\n\n/* .feedbackContent button:hover {\n    background-color: #f0f0f0;\n} */\n\n.ratingButton:hover {\n    transform: scale(1.05);\n    transition: transform 0.3s ease-in-out;\n}\n\n.ratingButton img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.closeIcon {\n    cursor: pointer;\n}\n\n.rating {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n\n.textFeedback {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  background-color: #f7f7f7;\n  border-radius: 5px;\n  border: 0.5px solid #d7d7d7;\n  padding: 5px;\n  width:300px;\n}\n\n.textFeedback textarea {\n  width: 100%;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  resize: none;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.2;\n  background-color: transparent;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.textFeedback textarea:focus {\n  outline: none;\n}\n\n.feedbackSendButton {\n  background-color: var(--qa-primary);\n  color: rgb(105, 105, 105);\n  opacity: 0.6;\n  padding: 0px 8px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  align-self: flex-end;\n  font-size: 16px;\n}\n\n.feedbackSendButton:hover {\n  opacity: 1;\n}\n\n.feedbackSendIcon {\n  font-size: 20px;\n}\n\n.feedbackThankYou {\n  font-size: 20px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export var feedbackPopUp = `tFA53HLM49TojgswKpgw`;
export var feedbackHeader = `wuVTcOx9Cyla0bXuLREg`;
export var feedbackContent = `fRKBqBbl0zAPaYP2jAY0`;
export var ratingButton = `u_kMnwAo_LtK74Pw8crQ`;
export var closeIcon = `fp2Vddi8CjvvnhiRxEvS`;
export var rating = `lqJif_9RGRt2DpEY_4Um`;
export var textFeedback = `EGJ7IWl6dkBMy00XsLiR`;
export var feedbackSendButton = `ZT25zWpgswIDHvBACbN1`;
export var feedbackSendIcon = `N0MmVqhXhhby2u0KoBV3`;
export var feedbackThankYou = `SIwfy4sfM2OBjatKyugx`;
export default ___CSS_LOADER_EXPORT___;
